/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SelectAndStartProgramRequest
 */
export interface SelectAndStartProgramRequest {
    /**
     * 
     * @type {number}
     * @memberof SelectAndStartProgramRequest
     */
    programIndex: number;
}

/**
 * Check if a given object implements the SelectAndStartProgramRequest interface.
 */
export function instanceOfSelectAndStartProgramRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "programIndex" in value;

    return isInstance;
}

export function SelectAndStartProgramRequestFromJSON(json: any): SelectAndStartProgramRequest {
    return SelectAndStartProgramRequestFromJSONTyped(json, false);
}

export function SelectAndStartProgramRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SelectAndStartProgramRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'programIndex': json['programIndex'],
    };
}

export function SelectAndStartProgramRequestToJSON(value?: SelectAndStartProgramRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'programIndex': value.programIndex,
    };
}

